// store/slices/ordersSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { REACT_APP_API } from "../consts/consts";

// 🔥 NUEVO
export const fetchOrderById = createAsyncThunk(
  "orders/fetchById",
  async (orderId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`${REACT_APP_API}orders/${orderId}`);
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error al obtener el pedido"
      );
    }
  }
);


/* ================= THUNK ================= */

export const createOrder = createAsyncThunk(
  "order/create",
  async (orderData, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}orders/add`,
        orderData
      );
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Error al crear la orden"
      );
    }
  }
);

/* ================= SLICE ================= */

const initialState = {
  currentOrder: null,
  checkoutCustomer: null,
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setCheckoutCustomer(state, action) {
      state.checkoutCustomer = action.payload;
    },
    clearOrder(state) {
      state.currentOrder = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.currentOrder = action.payload;
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 🔥 FETCH ORDER BY ID
      .addCase(fetchOrderById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.loading = false;
        // 🔥 Normalizamos: si viene array, tomamos el primero
        state.currentOrder = Array.isArray(action.payload)
          ? action.payload[0]
          : action.payload;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCheckoutCustomer, clearOrder } = orderSlice.actions;
export default orderSlice.reducer;
